import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { useSiteContext } from "@americanbible/uikit";
import OutsideClickHandler from "react-outside-click-handler";

import { DropdownTrigger, DropdownContent } from "../../../AppBar/Dropdown";
import { BibleList } from "./BibleList/BibleList";
import { AllBiblesList } from "./AllBiblesList";
import { withBible } from "../../../Bible/BibleContainer";
import BookLibraryIcon from "../../../../icons/BookLibraryIcon";
import { getMaxMenuHeight } from "../utils";

const BibleDropdown = ({
  bible,
  parallelIds = [],
  parallelIndex = null,
  platformType,
  isOpen,
  toggle,
  theme
}) => {
  const { includeAllBibles } = useSiteContext();

  const handleBibleClick = bibleId => {
    toggle(true);
    bible.onBibleSelect(bibleId, parallelIndex);
  };

  const bibles = bible.getBibles();
  const bibleId =
    parallelIndex !== null
      ? bible.parallelBibleIds[parallelIndex]
      : bible.currentBibleId;
  const currentBible = bible.biblesById[bibleId];

  if (!currentBible) return null;

  return (
    <div>
      <DropdownTrigger arrow toggle={() => toggle()} isOpen={isOpen}>
        {currentBible && currentBible.abbreviationLocal && (
          <BookLibraryIcon fill={theme.appBarText} size={24} />
        )}
      </DropdownTrigger>
      <OutsideClickHandler
        onOutsideClick={() => {
          if (isOpen) toggle();
        }}
      >
        {includeAllBibles ? (
          isOpen && (
            <AllBiblesList
              bibles={bibles}
              siteBibleIds={bible.siteBibleIds}
              currentBible={currentBible}
              onBibleClick={handleBibleClick}
            />
          )
        ) : (
          <DropdownContent
            isOpen={isOpen}
            style={{ height: getMaxMenuHeight() }}
          >
            <BibleList
              bibles={bibles}
              siteBibleIds={bible.siteBibleIds}
              currentBible={currentBible}
              onBibleClick={handleBibleClick}
            />
          </DropdownContent>
        )}
      </OutsideClickHandler>
    </div>
  );
};

BibleDropdown.propTypes = {
  bible: PropTypes.shape({
    currentBibleId: PropTypes.string.isRequired,
    parallelBibleIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    getCurrentBible: PropTypes.func.isRequired,
    onBibleSelect: PropTypes.func.isRequired,
    onAddParallel: PropTypes.func.isRequired,
    getBibles: PropTypes.func.isRequired,
    biblesById: PropTypes.shape({})
  }).isRequired,
  parallelIds: PropTypes.arrayOf(PropTypes.string),
  parallelIndex: PropTypes.number,
  platformType: PropTypes.string.isRequired
};

export default withTheme(withBible(BibleDropdown));
